import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useBannerOrBlocker } from "../../../hooks";
import { Checkbox } from "../..";
import { CookiePropertyList } from ".";
import { useStylesheet } from "../../../contexts";
import { extendCommonGroupsStylesheet } from "@devowl-wp/web-cookie-banner";
const Cookie = (param)=>{
    let { cookie, checked, disabled, onToggle, propertyListProps = {} } = param;
    const { Cookie } = useStylesheet().extend(...extendCommonGroupsStylesheet);
    const { name } = cookie;
    const { group: { descriptionFontSize } } = useBannerOrBlocker();
    return /*#__PURE__*/ _jsxs(Cookie, {
        children: [
            /*#__PURE__*/ _jsx(Checkbox, {
                isChecked: checked,
                isDisabled: disabled,
                fontSize: descriptionFontSize,
                onToggle: onToggle,
                children: /*#__PURE__*/ _jsx("strong", {
                    children: name
                })
            }),
            /*#__PURE__*/ _jsx(CookiePropertyList, {
                cookie: cookie,
                ...propertyListProps,
                isDisabled: !checked
            })
        ]
    });
};
export { Cookie };
